import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { Header } from 'components/DonatePanel/Header'
import { MobilePanelContainer } from 'components/DonatePanel/MobilePanelContainer'
import { DonateForm } from '../DonateForm'
import type { DonateMobileProps } from '..'

export function MobileView({ project, dift }: DonateMobileProps) {
  const locale = useNextLocale()

  if (project) {
    return (
      <MobilePanelContainer project={project}>
        <Header project={project} locale={locale} dift={dift} />
        <DonateForm project={project} locale={locale} dift={dift} />
      </MobilePanelContainer>
    )
  }

  return null
}
